import { Link } from 'react-router-dom';
import { siteConfig, footerLinks } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              韩漫网 —— 提供最新最全的韩国漫画资源，所有内容免费在线观看。精选优质韩漫，打造极致的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              <a href="#navigation">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">
              <a href="#support">帮助支持</a>
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-background-200 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-background-200 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-background-200 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ" rel="nofollow">
                <i className="ri-qq-line text-background-200 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="Bilibili" rel="nofollow">
                <i className="ri-bilibili-line text-background-200 text-base"></i>
              </a>
            </div>
            <p className="text-xs text-background-500 mt-4">
              联系邮箱：contact@hanman.example.com
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} {siteConfig.name} 版权所有 | 京ICP备xxxxxxxx号
          </p>
          <p className="text-xs text-background-500">
            本站所有漫画资源仅供学习交流，请于下载后24小时内删除
          </p>
        </div>
      </div>
    </footer>
  );
}